<template>
    <div class="accordion-item" :id="id">
        <div @click="accordionClick()" class="accordion-item-title d-block" :class="{active:isActive}">{{name}}</div>
        <!--Plus Icon-->
        <svg class="expand-icon" alt="" aria-hidden="true" v-if="!isActive" xmlns='http://www.w3.org/2000/svg' width='19' height='19'><path d='M9.5 2v15M2 9.5h15' fill='none' fill-rule='evenodd' stroke='#000' stroke-linecap='square' stroke-width='1.2' /></svg>
        <!--Minus Icon-->
        <svg class="expand-icon" alt="" aria-hidden="true" v-if="isActive" xmlns='http://www.w3.org/2000/svg' width='19' height='19'><path d='M2 9.5h15' fill='none' fill-rule='evenodd' stroke='#000' stroke-linecap='square' stroke-width='1.2' /></svg>
        <div class="accordion-item-contents" v-show="isActive"><slot></slot></div>
    </div>
</template>
<script>
export default {
  name: "AccordionItem",
  props: {
        name: { required: true },
        collapsed: { default: false },
        selected: { default: false },
        id: { default: "" }
    },
    data() {
        return {
            isActive: false
        };
    },
    computed: {

    },
    methods: {
        accordionClick() {
            this.isActive = !this.isActive;
            this.$emit('resize');
        }
    },
    mounted() {
        this.isActive = this.selected;
    },
};
</script>